// elements/theming/color-shades.ts
var lighten = (color, amount) => {
  const isRgb = color.toLowerCase().startsWith("rgb");
  return rgbLogShade(isRgb ? color : hexToRgba(color), amount * 0.1);
};
var darken = (color, amount) => {
  const isRgb = color.toLowerCase().startsWith("rgb");
  return rgbLogShade(isRgb ? color : hexToRgba(color), -amount * 0.1);
};
var makeTransparent = (color, amount) => {
  const _opacity = Math.round(Math.min(Math.max(1 - amount, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};
var hexToRgba = (hex) => {
  let c;
  let cString;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    cString = "0x" + c.join("");
    return "rgba(" + [cString >> 16 & 255, cString >> 8 & 255, cString & 255].join(",") + ",1)";
  }
  throw new Error("Bad Hex " + hex);
};
var rgbaToHex = (rgba) => {
  let a;
  const rgb = rgba.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  const alpha = (rgb && rgb[4] || "").trim();
  let hex = rgb ? (rgb[1] | 1 << 8).toString(16).slice(1) + (rgb[2] << 8).toString(16).slice(1) + (rgb[3] << 8).toString(16).slice(1) : rgba;
  if (alpha !== "") {
    a = +alpha;
  } else {
    a = 1;
  }
  a = (a * 255 | 1 << 8).toString(16).slice(1);
  hex = hex + a;
  return hex;
};
var rgbLogShade = (color, ratio) => {
  const r = Math.round;
  const [a, b, c, d] = color.split(",");
  const pTemp = ratio < 0;
  const t = pTemp ? 0 : ratio * 255 ** 2;
  const P = pTemp ? 1 + ratio : 1 - ratio;
  return "rgb" + (d ? "a(" : "(") + r((P * parseInt(a[3] == "a" ? a.slice(5) : a.slice(4)) ** 2 + t) ** 0.5) + "," + r((P * parseInt(b) ** 2 + t) ** 0.5) + "," + r((P * parseInt(c) ** 2 + t) ** 0.5) + (d ? "," + d : ")");
};
export {
  darken,
  hexToRgba,
  lighten,
  makeTransparent,
  rgbaToHex
};
